<template>
  <section>

    <div class="live-score" v-if="mode === 'preview'">

      <div v-if="isTennis || isTableTennis" class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
<!--              <div class="ping-serving" v-if="isServing(player.position)"></div>-->
              <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>

      <div v-else-if="isBasket || isAussieRules" class="score-basket-wrapper">
        <div class="score-basket">
          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

          <div class="current-quarter">
            <div class="current-game-row" v-for="(player, idx) in players" :key="idx">
            <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="generic-score">
        <span class="home">{{ genericScore.home }}</span>
        <span class="away">{{ genericScore.away }}</span>
      </div>

    </div>

    <div class="live-score detail" :class="{ board: isBoard }" v-else>

      <!-- Tennis and table tennis always get names, current score and the period
           columns; basketball too on the board (mobile, above the tracker's court). -->
      <div v-if="isTennis || isTableTennis || (isBoard && isBasket)" class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
              <div class="player-name">
                <div v-if="!isBasket" class="ping-serving" :class="isServing(player.position) ? 'current' : ''"></div>
                <span class="player-name-text">{{player.name}}</span>
              </div>
              <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>

      <!-- Australian football: points per quarter with goals.behinds below,
           the half-time (INT.) and the total. -->
      <div v-else-if="isAussieRules" class="afl-score">
        <div class="afl-row afl-header">
          <span class="afl-name"></span>
          <span class="afl-cell" v-for="col in aflColumns" :key="col.key" :class="{ total: col.key === 'tot' }">
            {{ col.label }}
          </span>
        </div>
        <div class="afl-row" v-for="(player, idx) in players" :key="idx">
          <span class="afl-name">{{ player.name }}</span>
          <span class="afl-cell" v-for="col in aflColumns" :key="col.key"
                :class="{ total: col.key === 'tot', current: col.current }">
            <template v-if="col.score">
              <span class="afl-points">{{ col.score[player.position].points }}</span>
              <span class="afl-gb">{{ formatGoalsBehinds(col.score[player.position]) }}</span>
            </template>
          </span>
        </div>
      </div>

      <div v-else-if="isBasket" class="score-basket-wrapper">
        <div class="score-basket">
          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

          <div class="current-quarter">
            <div class="current-game-row" v-for="(player, idx) in players" :key="idx">
            <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="generic-score">
        <span class="home">{{ genericScore.home }}</span>
        -
        <span class="away">{{ genericScore.away }}</span>
      </div>

    </div>


  </section>
</template>

<script>
  export default {
    name: 'ScoreboardLive',

    props: {
      sportId: {
        type: [String, Number],
        required: true
      },
      livescore: {
        type: Object,
        required: false,
        default: () => ({})
      },
      // 'preview' | 'detail' | 'board' (detail laid out for the mobile tracker)
      mode: {
        type: String,
        required: false,
        default: "preview"
      },
      competitors: {
        type: Object,
        required: false,
        default: null
      }
    },

    computed: {
      /* ================= FLAGS ================= */
      isTennis() {
        return String(this.sportId) === "54094";
      },
      isBasket() {
        return ["48242", "1149105", "1149097"].includes(String(this.sportId));
      },
      isTableTennis() {
        return String(this.sportId) === "265917";
      },
      isAussieRules() {
        return String(this.sportId) === "389537";
      },
      isBoard() {
        return this.mode === 'board';
      },
      isDarts() {
        return String(this.sportId) === "154923";
      },

      /* ================= COMMON ================= */
      players() {
        if(this.competitors)
          return [{ "position": "1", name: this.competitors.home }, { "position": "2" , name: this.competitors.away}];
        else
          return [{ "position": "1" }, { "position": "2" }];
      },

      /* ================= TENNIS / BASKET SETS ================= */
      sets() {
        // FIX: Check assoluto su livescore e periods
        if (!this.livescore || !this.livescore.periods || !Array.isArray(this.livescore.periods)) return [];

        // Table tennis goes up to 7 games, tennis up to 5 sets, Aussie rules 4 quarters.
        const last = this.isTableTennis ? 7 : (this.isAussieRules ? 4 : 5);
        return this.livescore.periods
                .filter(p => p && Number(p.type) <= last)
                .sort((a, b) => Number(a.type) - Number(b.type));
      },

      /* ================= AUSSIE RULES ================= */
      // 1°, 2°, INT., 3°, 4°, (OT), Tot. Quarters not played yet stay empty.
      aflColumns() {
        const periods = (this.livescore && Array.isArray(this.livescore.periods)) ? this.livescore.periods : [];
        const byType = type => periods.find(p => p && String(p.type) === type) || null;
        const quarter = type => {
          const p = byType(type);
          return { key: type, label: type + '°', score: p ? this.aflPeriodScore(p) : null, current: !!p && !p.isFinished };
        };
        const sum = scores => {
          const valid = scores.filter(Boolean);
          if (!valid.length) return null;
          const out = {};
          ['1', '2'].forEach(pos => {
            const parts = valid.map(s => s[pos]);
            const known = parts.every(x => x.goals !== null);
            out[pos] = {
              points: parts.reduce((t, x) => t + x.points, 0),
              goals: known ? parts.reduce((t, x) => t + x.goals, 0) : null,
              behinds: known ? parts.reduce((t, x) => t + x.behinds, 0) : null
            };
          });
          return out;
        };

        const q = ['1', '2', '3', '4'].map(quarter);
        const columns = [q[0], q[1], { key: 'int', label: this.$t('halftimeShort'), score: q[1].score ? sum([q[0].score, q[1].score]) : null }, q[2], q[3]];
        if (byType('40')) columns.push({ key: '40', label: 'OT', score: this.aflPeriodScore(byType('40')), current: !byType('40').isFinished });
        columns.push({ key: 'tot', label: this.$t('totalShort'), score: sum(columns.filter(c => c.key !== 'int').map(c => c.score)) || this.aflEmptyScore() });
        return columns;
      },

      currentGame() {
        if (!this.livescore || !this.livescore.periods || !Array.isArray(this.livescore.periods)) return null;
        return this.livescore.periods.find(p => p && p.type === '60') || null;
      },

      /* ================= GENERIC (CALCIO) ================= */
      genericScore() {
        // Darts: the scoreboard only counts sets (0-0 in a legs-only match),
        // the legs are in the set period (type 1, or the set being played).
        const dartsResults = this.isDarts ? this.dartsLegResults() : null;
        if (dartsResults) {
          const h = dartsResults.find(r => r && String(r.position) === '1');
          const a = dartsResults.find(r => r && String(r.position) === '2');
          return { home: h ? h.value : '0', away: a ? a.value : '0' };
        }
        // FIX: Nessun optional chaining (?.), usiamo check espliciti per massima compatibilità Babel
        if (!this.livescore || !this.livescore.scoreboard || !this.livescore.scoreboard.results || !Array.isArray(this.livescore.scoreboard.results)) {
          return { home: '-', away: '-' };
        }

        const results = this.livescore.scoreboard.results;
        const homeResult = results.find(r => r && String(r.position) === '1');
        const awayResult = results.find(r => r && String(r.position) === '2');

        return {
          home: homeResult ? homeResult.value : '0',
          away: awayResult ? awayResult.value : '0'
        };
      }
    },

    methods: {
      dartsLegResults() {
        if (!this.livescore || !Array.isArray(this.livescore.periods)) return null;
        const sb = this.livescore.scoreboard;
        const current = String(sb && sb.currentPeriod);
        const periods = this.livescore.periods;
        const period = periods.find(p => p && String(p.type) === current && parseInt(current) < 60) ||
                periods.find(p => p && String(p.type) === '1');
        return period && Array.isArray(period.results) ? period.results : null;
      },
      /* ================= AUSSIE RULES ================= */
      aflEmptyScore() {
        return { '1': { points: 0, goals: 0, behinds: 0 }, '2': { points: 0, goals: 0, behinds: 0 } };
      },

      // Points of the quarter, split into goals (6) and behinds (1) by walking the
      // scoring incidents in order. The incidents' results are the score after
      // each one, either of the quarter or of the match: in the second case we
      // start from the previous quarters' totals. If the incidents don't add up
      // to the quarter's points, goals/behinds are unknown (null).
      aflPeriodScore(period) {
        const value = (results, pos) => {
          const r = Array.isArray(results) ? results.find(x => x && String(x.position) === pos) : null;
          return r ? Number(r.value) || 0 : 0;
        };
        const points = { '1': value(period.results, '1'), '2': value(period.results, '2') };

        const states = (Array.isArray(period.incidents) ? period.incidents : [])
                .filter(i => i && Array.isArray(i.results))
                .map(i => ({ '1': value(i.results, '1'), '2': value(i.results, '2') }))
                .sort((a, b) => (a['1'] + a['2']) - (b['1'] + b['2']));

        let base = { '1': 0, '2': 0 };
        const last = states[states.length - 1];
        if (last && last['1'] + last['2'] > points['1'] + points['2']) {
          this.livescore.periods
                  .filter(p => p && Number(p.type) < Number(period.type))
                  .forEach(p => { base = { '1': base['1'] + value(p.results, '1'), '2': base['2'] + value(p.results, '2') }; });
        }

        const out = {};
        ['1', '2'].forEach(pos => {
          let goals = 0, behinds = 0, prev = base[pos];
          states.forEach(s => {
            const d = s[pos] - prev;
            if (d > 0) { goals += Math.floor(d / 6); behinds += d % 6; }
            prev = s[pos];
          });
          const ok = goals * 6 + behinds === points[pos];
          out[pos] = { points: points[pos], goals: ok ? goals : null, behinds: ok ? behinds : null };
        });
        return out;
      },

      formatGoalsBehinds(score) {
        return score && score.goals !== null ? score.goals + '.' + score.behinds : '';
      },

      isServing(position) {
        if (!this.livescore || !this.livescore.livescoreExtraData || !Array.isArray(this.livescore.livescoreExtraData)) return false;

        const serve = this.livescore.livescoreExtraData.find(e => e && e.name === 'Turn');
        if (!serve) return false;

        return String(position) === String(serve.value);
      },

      /* ================= HELPERS ================= */
      getSetScore(set, position) {
        if (!set || !set.results || !Array.isArray(set.results)) return '-';
        const res = set.results.find(r => r && String(r.position) === String(position));
        return res ? res.value : '0';
      },

      winnerPeriod(set, position) {
        if (!set || !set.isFinished || !set.results || !Array.isArray(set.results)) return false;

        const target = set.results.find(r => r && String(r.position) === String(position));
        if (!target) return false;

        const targetValue = Number(target.value);
        return set.results.every(r => r && Number(r.value) <= targetValue);
      },

      getGameScore(position) {
        if (this.isTennis) {
          if (!this.currentGame || !this.currentGame.results || !Array.isArray(this.currentGame.results)) return '0';
          const res = this.currentGame.results.find(r => r && String(r.position) === String(position));
          return res ? res.value : '0';
        }

        // Aussie rules: total points, from the quarters (scoreboard as fallback).
        if (this.isAussieRules && this.sets.length) {
          return String(this.sets.reduce((t, set) => t + (Number(this.getSetScore(set, position)) || 0), 0));
        }

        // Table tennis: games won, counted from the finished games (periods 1..7,
        // whose results are the points of that game). Scoreboard as fallback.
        if (this.isTableTennis && this.sets.length) {
          return String(this.sets.filter(set => this.winnerPeriod(set, position)).length);
        }

        // Basketball: total points; table tennis / Aussie rules without periods: scoreboard.
        if (this.isBasket || this.isTableTennis || this.isAussieRules) {
          if (!this.livescore || !this.livescore.scoreboard || !this.livescore.scoreboard.results || !Array.isArray(this.livescore.scoreboard.results)) return '0';
          const res = this.livescore.scoreboard.results.find(r => r && String(r.position) === String(position));
          return res ? res.value : '0';
        }

        return '';
      }
    }
  }
</script>

<style scoped>
  .live-score {
    font-size: var(--font-size-4xl);
  }

  /* ===== TENNIS ===== */
  .tennis-score { display: flex; align-items: center; }
  .score-period { display: flex; gap: 8px; align-items: flex-end; }

  .current-period {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    padding-right: 8px;
    justify-content: center;
    min-width: 25px;
    overflow: visible;
  }

  .period {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 15px;
  }

  .period-header { font-size: var(--font-size-xs); color: rgba(255, 255, 255, 0.5); margin-bottom: 2px; }
  .period-value { color: #fff; font-weight: 400; font-size: var(--font-size-3xl); line-height: 1.4; }
  .period-value.win { font-weight: 800; color: #fff; }
  .period-value.current { color: var(--color-secondary); font-weight: 700; }

  .current-game-row {
    position: relative;
    display: flex;
    justify-content: flex-end;
    height: 18px;
    align-items: center;
    overflow: visible;
  }

  .current-game {
    font-weight: 800;
    color: var(--color-secondary);
    font-size: var(--font-size-3xl);
  }

  .ping-serving {
    height: 5px; width: 5px;
    background: hsla(0, 0%, 100%, .4);
    border-radius: 50%;
    z-index: 10;
  }
  .ping-serving.current {
    background: var(--color-secondary);
    animation: ping 1s infinite;
  }

  @keyframes ping {
    0% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(1.2); }
    100% { opacity: 1; transform: scale(1); }
  }

  /* ===== BASKET ===== */
  .score-basket-wrapper { display: flex; }
  .score-basket { display: flex; gap: 8px; align-items: flex-end; }

  .current-quarter {
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    padding-left: 8px;
    justify-content: center;
  }

  /* ===== GENERIC (CALCIO) ===== */
  .generic-score {
    font-weight: 900;
    font-size: var(--font-size-6xl);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.3;
  }
  .home, .away { color: var(--color-secondary); }

  .player-name{
    font-size:var(--font-size-3xl);
  }

  .container_period {
    display: flex;
    gap: 8px; align-items: flex-end;
  }

  @media (max-width: 600px) {
    .match-time { margin-bottom: 0; }
    .generic-score{
      line-height: 16px;
      gap: 8px;
    }
    .generic-score, .period-value, .current-game { font-size: var(--font-size-4xl); }
    .score-period, .score-basket {
      max-width: 60px;
      overflow-x: auto;
      overflow-y: visible;
    }
    .live-score.detail .score-period{
      max-width: 100%!important;
    }
  }

  .live-score.detail .generic-score {
    display: flex;
    flex-direction: row;
    font-size: var(--font-size-10xl);
    gap: 2px;
    color: var(--text-platform);
  }
  .live-score.detail .generic-score .home, .live-score.detail .generic-score .away {

    color: var(--text-platform);
  }


  /* ===== TENNIS ===== */
  .live-score.detail .tennis-score {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .live-score.detail .score-period {
    display: flex;
    gap: 16px;
    align-items: last baseline;
    width: 100%;
  }

  .live-score.detail .current-period {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    padding-right: 8px;
    justify-content: center;
    min-width: 200px; /* spazio per nome completo */
    flex-shrink: 0;
  }

  .live-score.detail .current-game-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 24px;
  }

  .live-score.detail .player-name {
    font-size: var(--font-size-3xl);
    white-space: nowrap; /* evita il taglio */
    overflow: visible;
    min-width: 90px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .live-score.detail .current-game {
    font-weight: 800;
    color: var(--color-secondary);
    font-size: var(--font-size-4xl);
    min-width: 20px;
    text-align: right;
  }

  .live-score.detail .container_period {
    display: flex;
    gap: 12px;
    align-items: flex-end;
  }

  .live-score.detail .period {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 22px;
  }
  .live-score.detail .period-value{
    min-height: 24px;
  }

  /* ===== AUSSIE RULES ===== */
  .afl-score {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }
  .afl-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .afl-name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: var(--font-size-3xl);
    font-weight: 700;
    color: var(--text-platform);
  }
  .afl-cell {
    flex: 0 0 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.3;
  }
  .afl-header .afl-cell {
    font-size: var(--font-size-xs);
    color: rgba(255, 255, 255, 0.5);
  }
  .afl-points {
    font-size: var(--font-size-3xl);
    color: #fff;
  }
  .afl-gb {
    font-size: var(--font-size-xs);
    color: rgba(255, 255, 255, 0.6);
  }
  .afl-cell.current .afl-points { color: var(--color-secondary); font-weight: 700; }
  .afl-cell.total .afl-points { color: var(--color-secondary); font-weight: 800; }

  /* ===== BOARD (mobile, above the tracker) ===== */
  .live-score.detail.board .score-period {
    max-width: 100% !important;
    gap: 12px;
  }
  .live-score.detail.board .current-period {
    flex: 1 1 auto;
    min-width: 0;
  }
  .live-score.detail.board .player-name {
    min-width: 0;
    overflow: hidden;
  }
  .live-score.detail.board .player-name-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .live-score.detail.board .ping-serving {
    flex-shrink: 0;
  }
  .live-score.detail.board .container_period {
    flex-shrink: 0;
    max-width: 50%;
    overflow-x: auto;
  }

</style>